<template>
    <div>
        <div v-if="!isLoading" class="">
            <div v-if="item" class="">
                <div class="profile-wid-bg h-auto position-relative px-3 pt-3 mx-n4 mt-n4 mb-4">
                    <div class="row mb-4 g-4">
                        <div class="col-auto">
                            <div style="width: 6rem; height: 6rem;">
                                <div @click="showProfileImg(user.image)"
                                    class="cursor-pointer img-thumbnail border border-2 w-100 h-100 rounded"
                                    :style="`background-image: url(${absoluteUrl(user.image || noImageAvailable)}); 
                                        background-position: center center; background-size: cover;`">
                                </div>
                            </div>
                        </div>
                        <!--end col-->
                        <div class="col">
                            <div class="p-2">
                                <h3 class="text-white mb-1">{{ user.title || '' }} {{ user.first_name }} {{ user.last_name }}</h3>
                                <p class="text-white-75 mb-2"> Status: <span class="text-uppercase">{{
                                        $filters.textFromSlug(item.status) }}</span> </p>
                                <div class="d-sm-flex align-items-center text-white-50 gap-1">
                                    <div class="me-2">
                                        <i class="ri-phone-line me-1 text-white-75 fs-16 align-middle"></i>
                                        {{ user.mobile }}
                                    </div>
                                    <div v-if="user.email">
                                        <p style="word-break: break-all;" class="mb-0">
                                            <i class="ri-mail-line me-1 text-white-75 fs-16 align-middle"></i>{{
                                            $filters.truncate(user.email, 40) }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-auto order-last order-lg-0">
                            <div class="d-flex justify-content-between text-white-50 text-lg-end">
                                <div class="me-3">
                                    <h5 class="text-white mb-1">{{ $filters.addSeparator(item.employee_number, ' ')
                                        }}</h5>
                                    <p class="fs-14 mb-0">Employee Number</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="position-relative">
                                <div class="dynamic_scroll horizontal-scroll">
                                    <ul class="nav nav-pills animation-nav overflow-auto profile-nav justify-content-start flex-grow-1"
                                        role="tablist" :style="`min-width: ${98 * tabs.length}px;`">
                                        <li v-for="(tab, tbIndex) in tabs" :key="tbIndex" class="nav-item rounded-0">
                                            <button class="nav-link" aria-current="page" type="button"
                                                @click.prevent="activeTab = tab.key"
                                                :class="{ 'active': tab.key == activeTab }">
                                                <span class="span-label">{{ tab.title }}</span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="activeTab == '1'" class="">
                    <employee-profile :employee="item" />
                </div>
                <div v-else-if="activeTab == '2'" class="">
                    <employee-employment :employee="item" />
                </div>
                <div v-else-if="activeTab == '3'" class="">
                    <employee-education :employee="item" />
                </div>
                 <div v-else-if="activeTab == '4'" class="">
                    <employee-payment :employee="item" />
                </div>
                <div v-else-if="activeTab == '5'" class="">
                    <employee-dependants :employeeId="item.id" />
                </div>
            </div>
        </div>
        <CommonSpinner v-else />
    </div>
</template>

<script>
import EmployeeDependants from './EmployeeDependants.vue'
import EmployeeEducation from './EmployeeEducation.vue'
import EmployeeEmployment from './EmployeeEmployment.vue'
import EmployeePayment from './EmployeePayment.vue'
import EmployeeProfile from './EmployeeProfile.vue'

export default {
    name: "employee-show",
    components: {
        EmployeeProfile,
        EmployeeEmployment,
        EmployeeEducation,
        EmployeePayment,
        EmployeeDependants
    },
    data() {
        return {
            isLoading: true,
            tabs: [
                { key: "1", title: "Personal", icon: "" },
                { key: "2", title: "Employment", icon: "" },
                { key: "3", title: "Education", icon: "" },
                { key: "4", title: "Payment", icon: "" },
                { key: "5", title: "Dependants", icon: '' },
                { key: "6", title: "Documents", icon: '' },
            ],
            activeTab: "1",

            popupModalShow: false,
            popupRejectCandidate: false,
            item: null,
        }
    },
    watch: {
        '$route.params.employeeId': function (id) {
            if (id) this.fetchItem()
        },
    },
    computed:{
        user(){
            return this.item.user || this.fakeUserModel
        }
    },
    methods: {
        updateItem(item) {
            Object.assign(this.item, item)
        },
        fetchItem(showLoader = true){
            this.isLoading = showLoader;
            this.$http.get('/profile-settings')
                .then((response) => {
                this.isLoading = false
                if(response.data.success){
                    this.item = response.data.data
                }else{
                    this.$router.push({path: '/error-404'})
                }
            })
        },
        setActiveTab() {
            return this.activeTab = this.$route.query.tab ? this.$route.query.tab : '1';
        },
        initializeAll() {
            this.popupModalShow = false;
            this.popupRejectCandidate = false;
        }
    },
    created() {
        this.setActiveTab()
        this.fetchItem()
    },
}

</script>


<style>
.profile-nav .nav-item .nav-link {
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
}

@media(max-width: 576px) {
    .profile-nav .nav-item .nav-link {
        font-weight: 600;
        line-height: 1;
    }

    .profile-nav .nav-item .span-label {
        font-size: 12px;
    }
}

.animation-nav.profile-nav li a:hover,
.animation-nav.profile-nav li button:hover{
    color: var(--bs-light);
    background-color: rgba(var(--bs-light-rgb), .2) !important;
}


.animation-nav.profile-nav li a.active,
.animation-nav.profile-nav li button.active {
    color: var(--bs-primary);
    background-color: var(--bs-body-bg) !important;
}

</style>